import { useState } from "react";

export default function useComName() {
    const getComName = () => {
        const comNameString = localStorage.getItem('comName');
        const comName = JSON.parse(comNameString);
        return comName?.comName
    };

    const [comName, setComName] = useState(getComName());

    const saveComName = comName => {
        localStorage.setItem('comName', `{"comName":"${comName}"}`);
        setComName(comName);
    };

    return {
        setLoggedComName: saveComName,
        loggedComName: comName
    }
}
